import request from '@/utils/request'
// 查询配送类型列表
export const getDeliveryType = () => {
        return request({
            url: '/carrierDeliveryType',
            method: 'get',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
        });
    }
    // 保存配送类型列表
export const saveDeliveryType = (data) => {
    return request({
        url: '/carrierDeliveryType',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const getfreightsList = (data) => {
    return request({
        url: '/product-freights',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const excelfreightsList = (data) => {
    return request({
        url: '/product-freights/excel',
        method: 'get',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        fullResponse: true,
        responseType: 'blob',
        params: data
    });
}

export const getfreightsHistories = (data) => {
    return request({
        url: '/product-freights/' + data + '/histories',
        method: 'get',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },

    });
}
export const freightProhibited = (data) => {
    return request({
        url: '/product-freights?action=disable',
        method: 'put',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const freightEnable = (data) => {
    return request({
        url: '/product-freights?action=enable',
        method: 'put',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const changeInit = (data) => {
    return request({
        url: '/proApply/changeInit',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const createChange = (data) => {
    return request({
        url: '/proApply/createChangeApply',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}

export const sendToMDM = (idList) => {
    return request({
        url: '/api/sendProductFreightToMDM',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: idList
    });
}
export const materialPriceDataApi = {
    listProductFreightByMaterialCode: (data) => request({
        url: "/product-freights/listProductFreightByMaterialCode",
        method: 'post',
        data: data
    })
}